export default function nav() {
    $('.bar-btn').click(()=>{
        $('#js-hamburger-nav').width(250);
    });

    $('#js-hamburger-nav-close-btn').click(()=>{
        $('#js-hamburger-nav').width(0);
    });
}